const ShortLong = [
    {id: "0", value: "短天期"},     
    {id: "1", value: "長天期"},     
  ];  
  
  export default ShortLong  